<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-col gap-4 p-2">
    <div>Set priority order for {{ binCount }} bin{{ binCount !== 1 ? 's' : '' }}:</div>
    <div>
      <input #priorityInput pInputText type="number" [(ngModel)]="priorityOrder" min="1" title="Priority Order" class="w-full" />
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" (click)="ok()" [disabled]="!priorityOrder || priorityOrder <= 0">
      <span>Ok</span>
    </button>
    <button pButton type="button" class="p-button-raised" (click)="cancel()">
      <span>Cancel</span>
    </button>
  </div>
</ng-template>
